<template>
    <div
        class="ml-2 c-save-segment"
        style="display: inline-block;"
        @click.stop.prevent="onShowClick"
    >
        <slot name="trigger"></slot>
        <Modal v-model="creating" class-name="model__index_max">
            <p slot="header" class="text-center">Create token</p>
            <Form ref="tagForm" :model="formData" :rules="ruleValidate">
                <FormItem label="Name" prop="tagName">
                    <Input
                        v-model="formData.tagName"
                        placeholder="Name your token..."
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="onSubmitClick">Submit</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            creating: false,
            formData: {
                name: null,
            },
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: "The name cannot be empty",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {},
    methods: {
        async onSubmitClick() {
            var valid = await this.$refs.tagForm.validate();
            this.formData.name = this.formData.tagName;
            if (valid) {
                this.$emit("submit", this.formData);
                this.$refs.tagForm.resetFields();
                this.creating = false;
            }
        },
        onShowClick() {
            this.creating = true;
        },
    },
};
</script>
